module.exports = __webpack_public_path__ + "static/media/search.cf6a7897.svg";